import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import About from "@/pages/About";
import Testimonials from "@/pages/Testimonials";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";
import StudentDashboard from "@/pages/StudentDashboard";
import CoursePlayer from "@/pages/CoursePlayer";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAdmins from "@/pages/admin/AdminAdmins";
import AdminActivity from "@/pages/admin/AdminActivity";
import {
  AdminCourses, AdminOrders, AdminStudents, AdminOffers, AdminCoupons,
  AdminTestimonials, AdminFAQs, AdminMessages, AdminSiteContent, AdminSettings, AdminServices,
} from "@/pages/admin/AdminPages";
import Services from "@/pages/Services";
import Legal from "@/pages/Legal";
import { trackPageView } from "@/lib/pixel";

function PixelRouteTracker() {
  const location = useLocation();
  React.useEffect(() => {
    // fire on every client-side navigation (initial PageView already fires from index.html)
    trackPageView();
  }, [location.pathname]);
  return null;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <PixelRouteTracker />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/:slug" element={<CourseDetail />} />
      <Route path="/services" element={<Services />} />
      <Route path="/legal/:slug" element={<Legal />} />
      <Route path="/checkout/:slug" element={<Checkout />} />
      <Route path="/checkout/success/:orderId" element={<CheckoutSuccess />} />
      <Route path="/about" element={<About />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<StudentDashboard />} />
      <Route path="/learn/:slug" element={<CoursePlayer />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
      <Route path="/admin/reset-password" element={<AdminResetPassword />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="courses" element={<AdminCourses />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="students" element={<AdminStudents />} />
        <Route path="offers" element={<AdminOffers />} />
        <Route path="coupons" element={<AdminCoupons />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="faqs" element={<AdminFAQs />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="site-content" element={<AdminSiteContent />} />
        <Route path="admins" element={<AdminAdmins />} />
        <Route path="activity" element={<AdminActivity />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Router />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
